import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HelperService } from '../../services/helper.service';

@Component({
  selector: 'app-med-cost-popup',
  templateUrl: './med-cost-popup.component.html',
  styleUrls: ['./med-cost-popup.component.scss']
})
export class MedCostPopupComponent {
  tenant: any = localStorage.getItem('tenant')

  constructor(
    public dialogRef: MatDialogRef<MedCostPopupComponent>,
    public helperService: HelperService,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any) {
      this.props.sale_order_rx_detail.map((item:any)=>{ 
        //console.log("Data111",item); 
        
        item.Costs = item.Cost - (item.DiscountCost? item.DiscountCost: 0)
        item.Markups = item.Markup - (item.DiscountMarkup? item.DiscountMarkup: 0)
        item.Fees = item.Fee - (item.DiscountFee? item.DiscountFee: 0)
      })
      //console.log('Total Medication Expense', this.props)
  }

}
